export const SHORTCUT_LIST = [
  { value: 'Ad hijacking', text: 'How can I start monitoring and combating ad hijacking?' },
  { value: 'Brand bidding', text: 'How can I begin monitoring and combating brand bidding?' },
  { value: 'Competitor Ads', text: 'How do I begin tracking and analyzing my competitors’ ads?' },
  {
    value: 'Coupon Code',
    text: 'How do I get started with monitoring coupon code abuse and seeing the report?',
  },
  { value: 'Trademark abuse', text: 'How can I begin monitoring and combating trademark abuse?' },
]
